module.exports = __webpack_public_path__ + "img/xcl_bd.78e9f0b.png";